import script from "./CampaignMetrics.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignMetrics.vue?vue&type=script&setup=true&lang=js"

import "./CampaignMetrics.vue?vue&type=style&index=0&id=59398e5c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59398e5c"]])

export default __exports__